module.exports = __webpack_public_path__ + "img/automated.7efcba1f.svg";